import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _Summary;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@instructure/ui-text';
import { jsx } from '@instructure/emotion';
import { DISPLAY_AS_SUMMARY_LIMIT } from '../presenter';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/format-message';
import { withStyleOverrides } from '@instructure/quiz-common';
export var Summary = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_Summary = /*#__PURE__*/function (_Component) {
  function Summary() {
    var _this2;
    _classCallCheck(this, Summary);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, Summary, [].concat(args));
    _defineProperty(_this2, "handleShowItems", function () {
      if (_this2.props.isDragging) {
        return;
      }
      _this2.props.setSidebarStimulusIsShowing(_this2.props.stimulusId, !_this2.props.isShowingItems);
    });
    _defineProperty(_this2, "handleKeyDown", function (event) {
      if (event.keyCode === 13 || event.keyCode === 32) {
        // enter or space pressed
        _this2.handleShowItems();
      }
    });
    return _this2;
  }
  _inherits(Summary, _Component);
  return _createClass(Summary, [{
    key: "getCountText",
    value: function getCountText() {
      var _this$props = this.props,
        isDragging = _this$props.isDragging,
        startPosition = _this$props.startPosition,
        numberOfItems = _this$props.numberOfItems;
      if (isDragging) {
        if (numberOfItems > 1) {
          return t('Questions {first, number} - {second, number} Included', {
            first: startPosition,
            second: startPosition + numberOfItems - 1
          });
        }
        return t('Question {first, number} Included', {
          first: startPosition
        });
      }
      if (numberOfItems > 1) {
        return t('Questions {first, number} - {second, number}', {
          first: startPosition,
          second: startPosition + numberOfItems - 1
        });
      }
      return t('Question {first, number}', {
        first: startPosition
      });
    }

    // =============
    //   RENDERING
    // =============
  }, {
    key: "renderEndSectionContent",
    value: function renderEndSectionContent() {
      var _this$props2 = this.props,
        isDragging = _this$props2.isDragging,
        isShowingItems = _this$props2.isShowingItems;
      if (!isDragging) {
        return jsx(Text, {
          size: "small",
          weight: "light"
        }, isShowingItems ? t('Collapse') : t('Expand'));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var isDragging = this.props.isDragging;
      if (!isDragging && this.props.numberOfItems <= DISPLAY_AS_SUMMARY_LIMIT) {
        return null;
      }
      var id = "stimulus-summary-content-".concat(this.props.stimulusId);
      return jsx("div", {
        role: "button",
        tabIndex: "0",
        "aria-expanded": this.props.isShowingItems,
        "aria-controls": id,
        "data-testid": "summary",
        css: this.props.styles.summary,
        onClick: this.handleShowItems,
        onKeyDown: this.handleKeyDown
      }, jsx("div", {
        id: id,
        css: this.props.styles.itemsContainer,
        "data-testid": "items-container"
      }, jsx("div", {
        css: this.props.styles.questionCount,
        "data-testid": "question-count"
      }, jsx(Text, {
        size: "small",
        weight: "light"
      }, this.getCountText())), jsx("div", {
        css: this.props.styles.middleSection
      }), jsx("div", {
        css: this.props.styles.endSection
      }, this.renderEndSectionContent())));
    }
  }]);
}(Component), _defineProperty(_Summary, "displayName", 'Summary'), _defineProperty(_Summary, "componentId", "Quizzes".concat(_Summary.displayName)), _defineProperty(_Summary, "propTypes", {
  // Passed in by parent
  startPosition: PropTypes.number.isRequired,
  /* This is used for when the stimulus is being dragged in build */
  isDragging: PropTypes.bool,
  numberOfItems: PropTypes.number.isRequired,
  isShowingItems: PropTypes.bool,
  stimulusId: PropTypes.string.isRequired,
  // from connected component
  setSidebarStimulusIsShowing: PropTypes.func.isRequired,
  styles: PropTypes.object
}), _defineProperty(_Summary, "defaultProps", {
  isDragging: false,
  isShowingItems: false
}), _Summary)) || _class);
export default Summary;